import { createContext, useContext } from "react"
import type { TableContext as TableContextType } from "./types"

export const TableContext = createContext<TableContextType | undefined>(
  undefined,
)

export function useTableContext() {
  const ctx = useContext(TableContext)
  if (ctx === undefined) {
    throw new Error("useTableContext :(")
  }
  return ctx
}
